export default __webpack_public_path__ + "static/media/main_item_07.b6f79533.png";